import "core-js/modules/web.dom-collections.iterator.js";
import React, { useMemo, useState } from 'react';
import ExpandLess from '@pixel/assets/icons/ExpandLess';
import ExpandMore from '@pixel/assets/icons/ExpandMore';
import MoreVertIcon from '@pixel/assets/icons/MoreVert';
import { TransitionGroup } from 'react-transition-group';
import Typography from '../Typography';
import Box from '../Box';
import Collapse from '../Collapse';
import PixelIconButton from '../PixelIconButton';
import Menu from '../Menu';
import MenuItem from '../MenuItem';
const PageHeader = props => {
  const {
    title,
    renderTitle,
    renderActions,
    variant,
    outputActions,
    canToggleContent,
    isContentHidden,
    children,
    actionsList,
    contentPadding = true,
    ...restProps
  } = props;
  const [contentRevealed, setContentRevealed] = useState(true);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const outputH1Title = useMemo(() => /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    noWrap: true
  }, title), [title]);
  const outputH2Title = useMemo(() => /*#__PURE__*/React.createElement(Typography, {
    variant: "h2",
    noWrap: true
  }, title), [title]);
  const renderHeadingTitle = (title_variant, isRenderTitleFunction) => {
    if (title_variant && title_variant === 'subHeader') {
      return isRenderTitleFunction ? renderTitle(outputH1Title) : outputH2Title;
    }
    return isRenderTitleFunction ? renderTitle(outputH1Title) : outputH1Title;
  };
  const isRenderTitleFunction = Boolean(renderTitle) && typeof renderTitle === 'function';
  const isRenderActionFunction = Boolean(renderActions) && typeof renderActions === 'function';
  const handleToggleContent = () => {
    setContentRevealed(!contentRevealed);
  };
  const handleOpenUserMenu = event => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const outputContentPadding = contentPadding ? 1 : 0;
  return /*#__PURE__*/React.createElement(Box, restProps, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex"
    }
  }, canToggleContent && /*#__PURE__*/React.createElement(Box, {
    sx: {
      minWidth: 45
    }
  }, /*#__PURE__*/React.createElement(PixelIconButton, {
    onClick: handleToggleContent
  }, contentRevealed ? /*#__PURE__*/React.createElement(ExpandLess, null) : /*#__PURE__*/React.createElement(ExpandMore, null))), /*#__PURE__*/React.createElement(Box, {
    pl: canToggleContent ? 3 : 0,
    pr: canToggleContent ? 3 : 0,
    flex: 1,
    sx: {
      overflow: 'hidden'
    }
  }, renderHeadingTitle(variant, isRenderTitleFunction)), isRenderActionFunction ? renderActions(outputActions) : Array.isArray(actionsList) && actionsList.length && /*#__PURE__*/React.createElement(Box, {
    sx: {
      minWidth: 45
    }
  }, /*#__PURE__*/React.createElement(PixelIconButton, {
    onClick: handleOpenUserMenu
  }, /*#__PURE__*/React.createElement(MoreVertIcon, null)), /*#__PURE__*/React.createElement(Menu, {
    sx: {
      mt: '50px'
    },
    anchorEl: anchorElUser,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    keepMounted: true,
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    open: Boolean(anchorElUser),
    onClose: handleCloseUserMenu
  }, actionsList.map(action => /*#__PURE__*/React.createElement(MenuItem, {
    key: action.name,
    onClick: () => {
      action.action();
      handleCloseUserMenu();
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    textAlign: "center"
  }, action.name)))))), /*#__PURE__*/React.createElement(TransitionGroup, null, !isContentHidden && contentRevealed ? /*#__PURE__*/React.createElement(Collapse, null, /*#__PURE__*/React.createElement(Box, {
    pt: children ? outputContentPadding : 0,
    pb: children ? outputContentPadding : 0
  }, children)) : null));
};
export default PageHeader;